// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"f25dbf4b","186":"3af6de9d","435":"863b9b63","473":"4d24f12e","534":"371c5b51","645":"0777d707","729":"547f34c8","859":"2a8c9bcb"}[chunkId] + ".chunk.js";
};